// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1499":"cc00fa56","1871":"7146c2cb","2050":"69121393","3895":"69121393","5943":"69121393","8947":"7146c2cb"}[chunkId] + ".chunk.css";
};